module.exports = __webpack_public_path__ + "static/ramboll.ba201694.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/references/ramboll.svg
// module id = 214
// module chunks = 35783957827783 267625579013595